module.exports = __webpack_public_path__ + "static/chilli-beans-bg-ee9b6cddff8c912140c18fbcc2deeede.png";